<template>
  <div v-if="loaded" class="questionsPage">
    <FullScreen v-if="showModal" @close="showModal = false"></FullScreen>
    <QuestionMap
      v-show="showSidePanes"
      :mcqs="mcqs"
      :prog="Programming"
      :sub="Subjective"
      :current-section="currentSection"
      @changeSection="changeSection"
      @changeCurrent="changeCurrent"
    ></QuestionMap>
    <QuestionsList
      v-show="showSidePanes"
      :mcqs="getQuestionList"
      @changeCurrent="changeCurrent"
    ></QuestionsList>
    <QuestionDetail
      :total="this.mcqs.total"
      :curr-question="getCurrentQuestion"
      @onSubmitButtonPressed="onSubmitButtonPressed"
      @onMarkForReviewButtonPressed="onMarkForReviewButtonPressed"
      @onNextButtonPressed="onNextButtonPressed"
      @decTotal="decTotal"
      @hideSidePanes="hideSidePanes"
    ></QuestionDetail>
  </div>
</template>

<script>
import QuestionsList from './QuestionsList'
import QuestionMap from './QuestionMap'
import QuestionDetail from './QuestionDetail'
import FullScreen from '../components/FullScreen.vue'
import api from '../services/api.service'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'PracticeTest',
  components: { QuestionsList, QuestionMap, QuestionDetail, FullScreen },
  computed: mapState({
    getCurrentQuestion: function() {
      if (this.currentSection === 'mcqs') {
        return this.mcqs.questions[this.mcqs.current]
      } else if (this.currentSection === 'Subjective') {
        return this.Subjective.questions[this.Subjective.current]
      } else {
        return this.Programming.questions[this.Programming.current]
      }
    },
    getQuestionList: function() {
      if (this.currentSection === 'mcqs') {
        return this.mcqs
      } else if (this.currentSection === 'Subjective') {
        return this.Subjective
      } else {
        return this.Programming
      }
    },
    getTotal: function() {
      if (this.currentSection === 'mcqs') {
        return this.mcqs.total
      } else if (this.currentSection === 'Subjective') {
        return this.Subjective.total
      } else {
        return this.Programming.total
      }
    },
  }),
  methods: {
    ...mapActions(['endTest']),
    decTotal() {
      if (
        this[this.currentSection].questions[this[this.currentSection].current]
          .currentClass === 'saved' ||
        this[this.currentSection].questions[this[this.currentSection].current]
          .currentClass === 'reviewSubmit'
      ) {
        this[this.currentSection].totalSaved =
          this[this.currentSection].totalSaved - 1
      }
    },
    startClock() {
      this.$store.commit(
        'setTimer',
        setInterval(() => {
          this.$store.commit('durationLeftDecrement')
          sessionStorage.durationLeft = this.$store.state.test.durationLeft
          if (this.$store.state.test.durationLeft <= 0) {
            clearInterval(this.$store.state.timer)
            this.endTest(this.$router)
            window.close()
          }
        }, 1000)
      )
    },
    changeCurrent: function(newCurrent) {
      this[this.currentSection].current = newCurrent
    },
    nextQuestion: function() {
      if (
        this[this.currentSection].current ===
        this[this.currentSection].total - 1
      ) {
        if (this.currentSection === 'mcqs') {
          this.currentSection = 'Programming'
          this[this.currentSection].current = 0
          return
        }
        if (this.currentSection === 'Programming') {
          this[this.currentSection].current = 0
          return
        }
        if (this.currentSection === 'Subjective') {
          this[this.currentSection].current = 0
        }
      } else {
        this[this.currentSection].current =
          this[this.currentSection].current + 1
      }
    },
    onSubmitButtonPressed: function() {
      var temp = this[this.currentSection].current
      var tempSection = this.currentSection

      if (
        this[tempSection].questions[temp].currentClass !== 'saved' &&
        this[tempSection].questions[temp].currentClass !== 'reviewSubmit'
      ) {
        this[tempSection].totalSaved = this[tempSection].totalSaved + 1
      }
      this[tempSection].questions[temp].currentClass = 'saved'
      this[tempSection].questions[temp].saved = true
      if (this[tempSection].questions[temp].cls === 'MCQ') {
        for (let [key, value] of Object.entries(
          this[tempSection].questions[temp].options
        )) {
          if (value.value) {
            this[tempSection].questions[temp].lastSavedAnswer = key
          }
        }
      }
      this.nextQuestion()
    },
    onMarkForReviewButtonPressed: function() {
      var temp = this[this.currentSection].current
      var tempSection = this.currentSection
      if (this.isAnswered(temp)) {
        if (
          this[tempSection].questions[temp].currentClass === 'saved' ||
          this[tempSection].questions[temp].currentClass === 'reviewSubmit'
        ) {
          this[tempSection].totalSaved = this[tempSection].totalSaved - 1
        }
        this[this.currentSection].questions[
          this[this.currentSection].current
        ].currentClass = 'review'
        this[tempSection].questions[temp].lastSavedAnswer = ''
      } else {
        if (
          this[tempSection].questions[temp].currentClass !== 'saved' &&
          this[tempSection].questions[temp].currentClass !== 'reviewSubmit'
        ) {
          this[tempSection].totalSaved = this[tempSection].totalSaved + 1
        }
        this[tempSection].questions[temp].saved = true
        this[tempSection].questions[temp].currentClass = 'reviewSubmit'
        if (this[tempSection].questions[temp].cls === 'MCQ') {
          for (let [key, value] of Object.entries(
            this[tempSection].questions[temp].options
          )) {
            if (value.value) {
              this[tempSection].questions[temp].lastSavedAnswer = key
            }
          }
        }
      }
      this.nextQuestion()
    },
    onNextButtonPressed: function() {
      this.showSidePanes = true
      this.nextQuestion()
    },
    changeSection: function(name) {
      if (name === 'Multiple Choice Questions') {
        this.currentSection = 'mcqs'
      } else if (name === 'Programming') {
        this.currentSection = 'Programming'
      } else {
        this.currentSection = 'Subjective'
      }
    },
    exitHandler: function() {
      console.log('In Exit Handler')
      console.log(this.$store.state.timer)
      if (this.$store.state.timer === undefined) {
        this.startClock()
      }
      if (document.fullscreen === true || document.fullscreen === false) {
        this.showModal = !document.fullscreen
        console.log('in Fullscreen')
      } else if (
        document.webkitIsFullScreen === true ||
        document.webkitIsFullScreen === false
      ) {
        this.showModal = !document.webkitIsFullScreen
        console.log('in WebkitFullscreen')
      }
    },
    hideSidePanes() {
      this.showSidePanes = !this.showSidePanes
    },
    isAnswered(current) {
      var temp = false
      var currQuestion = this[this.currentSection].questions[current]
      if (currQuestion.options) {
        for (var value of Object.values(currQuestion.options)) {
          console.log(value)
          temp = temp || value.value
        }
      }
      if (currQuestion.answer && currQuestion.answer.length > 0) {
        temp = temp | true
      }
      return !temp
    },
    shuffle(array) {
      var currentIndex = array.length
      var temporaryValue
      var randomIndex
      while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1
        temporaryValue = array[currentIndex]
        array[currentIndex] = array[randomIndex]
        array[randomIndex] = temporaryValue
      }
      return array
    },
    shuffleOptions(dict) {
      var array = []
      for (let [key, value] of Object.entries(dict)) {
        array.push([key, value])
      }
      array = this.shuffle(array)
      var options = {}
      for (var ele in array) {
        options[' ' + array[ele][0]] = array[ele][1]
      }
      return options
    },
  },
  mounted: function() {
    this.$store.commit('setDuration', this.practiceTestDuration)
    this.$store.commit('setDurationLeft', this.practiceTestDuration)
    this.$store.commit('setName', this.testName)
    this.$store.commit('setCompanyName', this.companyName)
    this.$store.commit('setUserEmail', this.user_email)
    this.$store.commit('setTestId', this.test_id)
    this.$store.commit('setUserId', this.user_id)
    this.$store.commit('setTestType', this.testType)
    this.showModal = true
    api.getPracticeTestQuestions(this.test_id, this.user_id).then(response => {
      for (var question of response) {
        question['currentClass'] = 'normal'
        question['saved'] = true
        question['lastSavedAnswer'] = ''
        if (question._cls === 'MCQ') {
          question['number'] = this.mcqs.questions.length + 1
          question.options = this.shuffleOptions(question.options)
          this.mcqs.questions.push(question)
        } else if (question._cls === 'Subjective') {
          question['answer'] = ''
          question['number'] = this.Subjective.questions.length + 1
          this.Subjective.questions.push(question)
        } else {
          question['number'] = this.Programming.questions.length + 1
          question['code'] = ''
          question['language'] = 'java'
          question['typeOfResult'] = undefined
          question['submitResult'] = undefined
          this.Programming.questions.push(question)
        }
      }
      this.mcqs.total = this.mcqs.questions.length
      this.Subjective.total = this.Subjective.questions.length
      this.Programming.total = this.Programming.questions.length

      console.log(this.mcqs.questions)
      this.loaded = true

      api.startPracticeTest(this.test_id, this.user_id).then(response => {
        if (response['status'] === 'OK') {
          console.log("Practice Test")
        }
      })
    })

    window.onbeforeunload = function() {
      return 'Are you sure you want to leave'
    }

    document.fullscreenchange = this.exitHandler
    document.addEventListener('fullscreenchange', this.exitHandler)
    document.addEventListener('onwebkitfullscreenchange', this.exitHandler)
    document.fullscreenchange = this.exitHandler
    document.onwebkitfullscreenchange = this.exitHandler
  },
  data: function() {
    return {
      loaded: false,
      currentSection: 'mcqs',
      test_id: '5d1dbce889cac0334acd8e11',
      user_id: Date.now().toString(),
      user_email: 'headstart-user@infocusp.com',
      practiceTestDuration: 15*60,
      testName: 'Practice Test',
      testType: 'practice-test',
      companyName: 'HeadStart',
      mcqs: {
        total: 0,
        current: 0,
        totalSaved: 0,
        questions: [],
      },
      Subjective: {
        total: 0,
        current: 0,
        totalSaved: 0,
        questions: [],
      },
      Programming: {
        total: 0,
        current: 0,
        totalSaved: 0,
        questions: [],
      },
      showModal: false,
      showSidePanes: true,
    }
  },
  beforeDestroy() {
    clearInterval(this.$store.state.timer)
    window.onbeforeunload = null
    this.endTest(this.$router)
  },
}
</script>

<style scoped>
::-webkit-scrollbar {
  width: 4px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  background-color: #d0d0d0;
}

.questionsPage {
  -webkit-user-select: none; /* webkit (safari, chrome) browsers */
  -moz-user-select: none; /* mozilla browsers */
  -khtml-user-select: none; /* webkit (konqueror) browsers */
  -ms-user-select: none; /* IE10+ */
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  margin-top: 64px;
  justify-content: left;
  background: #f2f2f2;
  max-height: calc(100% - 64px);
}
</style>
